import axios from "axios";

const baseURL = "https://staging.backend.carchaser.ca/api";
const api = axios.create({
  baseURL,
});
const baseImageUrl = `https://staging.backend.carchaser.ca/uploads/`;
const baseVideoUrl = "https://staging.backend.carchaser.ca/videos/";

export default api;
export { baseURL, baseImageUrl, baseVideoUrl };
